import { Box, Container, Link, Typography, Grid, styled } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import StarsIcon from "@mui/icons-material/Stars";
import { cloneElement } from "react";

const FooterLower = styled(Box)(
	({ theme }) => `
        background: ${theme.colors.alpha.black[100]};
`
);

const FooterUpper = styled(Box)(
	({ theme }) => `
		position: relative;
		margin-top: ${theme.spacing(3)};
		padding: ${theme.spacing(4, 0)};
`
);

function FooterHome() {
	const baseUrl = window.location.origin;
	const playStoreUrl = "https://play.google.com/store/apps/details?id=com.brofesional.app";
	const appStoreUrl = "https://apps.apple.com/id/app/brofesional/id6747415242";
	const companyName = "CV. AFKA IDEAS SOLUSINDO";
	const contactInfo = [
		{
			label: "Admisi 1: 0878-3929-7479",
			href: "https://wa.me/6287839297479?text=Halo%20MinBro%20Diana%2C%20saya%20mengunjungi%20brofesional.id%20dan%20ingin%20berkonsultasi%20lebih%20lanjut",
			icon: <WhatsAppIcon style={{ color: "white", marginRight: "8px" }} />,
		},
		{
			label: "Admisi 2: 0812-3422-1504",
			href: "https://wa.me/6281234221504?text=Halo%20MinBro%20Winda%2C%20saya%20mengunjungi%20brofesional.id%20dan%20ingin%20berkonsultasi%20lebih%20lanjut",
			icon: <WhatsAppIcon style={{ color: "white", marginRight: "8px" }} />,
		},
		{
			label: "Telepon: +62 274-4281720",
			href: "tel:+622744281720",
			icon: <PhoneIcon style={{ color: "white", marginRight: "8px" }} />,
		},
		{
			label: "E-mail: bimbelyec@gmail.com",
			href: "mailto:bimbelyec@gmail.com",
			icon: (
				<EmailOutlinedIcon style={{ color: "white", marginRight: "8px" }} />
			),
		},
	];

	const socialMedia = [
		{
			label: "@bimbelYEC",
			href: "https://www.facebook.com/bimbelYEC",
			icon: <FacebookIcon style={{ color: "white", marginRight: "8px" }} />,
		},
		{
			label: "@bimbel_yec",
			href: "https://www.instagram.com/bimbel_yec/",
			icon: <InstagramIcon style={{ color: "white", marginRight: "8px" }} />,
		},
		{
			label: "@brofesional_id",
			href: "https://www.instagram.com/brofesional_id/",
			icon: <InstagramIcon style={{ color: "white", marginRight: "8px" }} />,
		},
		{
			label: "@brofesional_id",
			href: "https://x.com/brofesional_id",
			icon: <img src={`${process.env.REACT_APP_IMAGE_URL}static/images/icons/x_outlined.svg`} alt="x" style={{ color: "white", marginRight: "8px" }} />,
		},
		{
			label: "@BimbelYEC",
			href: "https://www.youtube.com/@BimbelYEC",
			icon: <YouTubeIcon style={{ color: "white", marginRight: "8px" }} />,
		},
		{
			label: "brofesionalid",
			href: "https://www.linkedin.com/company/brofesionalid/",
			icon: <LinkedInIcon style={{ color: "white", marginRight: "8px" }} />,
		},
	];

	const address = [
		{
			label: "Jl. Poncowolo 15, Ketanggungan, Wirobrajan, Yogyakarta 55252.",
			href: "https://maps.app.goo.gl/22ztEofUKpvZ3EuS7",
			icon: <MapsHomeWorkIcon style={{ color: "white", marginRight: "8px" }} />,
		},
		{
			label: "Berikan Ulasan",
			href: "https://g.page/r/CbQWYXslJEADEBM/review",
			icon: <StarsIcon style={{ color: "orange", marginRight: "8px" }} />,
		},
	];

	const appStores = [
		{
			label: "Google Play",
			href: playStoreUrl,
			badgeSrc: "/PlayStore.svg",
			alt: "Dapatkan di Google Play",
		},
		{
			label: "App Store",
			href: appStoreUrl,
			badgeSrc: "/AppStore.svg",
			alt: "Download di the App Store",
		},
	];

	const sectionTitleSx = {
		fontWeight: 700,
		letterSpacing: 0.2,
		mb: 2,
	};

	const linkSx = {
		color: "#D6DFEA",
		textDecoration: "none",
		transition: "color 0.2s ease",
		"&:hover": {
			color: "#FFFFFF",
			textDecoration: "underline",
			textUnderlineOffset: "3px",
		},
	};

	// Helper: 1 baris link biar ikon + teks sama-sama clickable (lebih enak di mobile)
	const FooterRowLink = ({ href, icon, label, external = true }) => (
		<Link
			href={href}
			target={external ? "_blank" : undefined}
			rel={external ? "noopener noreferrer" : undefined}
			underline="none"
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				py: 0.75, // bikin tap target lebih nyaman
				borderRadius: 1,
				color: "#D6DFEA",
				transition: "all 0.2s ease",
				"&:hover": {
					color: "#FFFFFF",
					backgroundColor: "rgba(255,255,255,0.06)",
				},
			}}
		>
			{/* Icon ikut hover karena pakai inherit */}
			<Box sx={{ display: "inline-flex", color: "inherit" }}>{icon}</Box>

			{/* Typography jangan override warna link */}
			<Typography variant="body2" sx={{ color: "inherit" }}>
				{label}
			</Typography>
		</Link>
	);

	const FooterUpperComponent = () => {
		return (
			<FooterUpper style={{ background: "#1D2939" }}>
				<Container>
					<Grid container spacing={{ xs: 0, md: 4 }} alignItems="stretch">
						<Grid item xs={12} md={6}>
							<Box
								sx={{
									height: "100%",
									display: "flex",
									flexDirection: "column",
									justifyContent: "center",
									mb: { xs: 2.5, md: 3 },
									pb: { xs: 1.5, md: 2 },
									// borderBottom: "1px solid rgba(255, 255, 255, 0.16)",
								}}>
								<Typography variant="caption" color="#9FB1C9" sx={{ letterSpacing: 0.8 }}>
									Dikelola oleh
								</Typography>
								<Typography variant="h5" color="white" sx={{ fontWeight: 800, mt: 0.5 }}>
									{companyName}
								</Typography>
							</Box>
						</Grid>
						<Grid item xs={12} md={6}>
							<Box
								sx={{
									height: "100%",
									display: "flex",
									flexDirection: "column",
									justifyContent: "center",
									mb: { xs: 2.5, md: 3 },
									pb: { xs: 1.5, md: 2 },
									// my: { xs: 1.5, md: 3 },
									// pt: { xs: 2, md: 2.5 },
									// borderTop: "1px solid rgba(255, 255, 255, 0.16)",
								}}>
								<Typography variant="h6" color="white" sx={{ ...sectionTitleSx, mb: 1.5, textAlign: { xs: "flex-start", md: "right" } }}>
									Download Aplikasi Brofesional
								</Typography>
								<Box
									sx={{
										display: "grid",
										gridTemplateColumns: { xs: "repeat(2, minmax(0, 150px))", sm: "repeat(2, 150px)" },
										justifyContent: { xs: "flex-start", md: "flex-end" },
										gap: 1.5,
										alignItems: "center",
									}}
								>
									{appStores.map((store, index) => (
										<Link
											key={`footer-store-${index}`}
											href={store.href}
											target="_blank"
											rel="noopener noreferrer"
											underline="none"
											sx={{ display: "block" }}
											aria-label={store.label}
										>
											<Box
												sx={{
													transition: "transform 0.2s ease, filter 0.2s ease",
													"&:hover": { transform: "translateY(-2px)", filter: "brightness(1.04)" },
												}}
											>
												<Box component="img" src={store.badgeSrc} alt={store.alt} sx={{ width: "100%", height: "auto" }} />
											</Box>
										</Link>
									))}
								</Box>
							</Box>
						</Grid>
					</Grid>

					<Grid container spacing={{ xs: 3, md: 4 }} sx={{ mb: 2 }}>
						<Grid item xs={12} sm={6} md={3}>
							<Box mb={2}>
								<Typography variant="h5" color="white" sx={sectionTitleSx}>
									Kontak
								</Typography>
							</Box>
							{contactInfo.map((contact, index) => (
								<Box key={`footer-contact-${index}`} sx={{ mb: 0.5 }}>
									<FooterRowLink
										href={contact.href}
										icon={cloneElement(contact.icon, { sx: { fontSize: 20 } })}
										label={contact.label}
										external={contact.href.startsWith("http")}
									/>
								</Box>
							))}
						</Grid>
						<Grid item xs={12} sm={6} md={3}>
							<Box mb={2}>
								<Typography variant="h5" color="white" sx={sectionTitleSx}>
									Media Sosial
								</Typography>
							</Box>
							{socialMedia.map((contact, index) => (
								<Box
									key={`footer-social-${index}`}
									sx={{ display: "flex", alignItems: "center", mb: 1.25 }}>
									{contact.icon}
									<Link href={contact.href} target="_blank" rel="noopener noreferrer" sx={linkSx}>
										<Typography variant="body1" color="white">
											{contact.label}
										</Typography>
									</Link>
								</Box>
							))}
						</Grid>
						<Grid item xs={12} sm={6} md={3}>
							<Box mb={2}>
								<Typography variant="h5" color="white" sx={sectionTitleSx}>
									Jam Operasional
								</Typography>
							</Box>
							<Box>
								<Typography variant="body2" color="white" sx={{ mb: 1.2 }}>
									Senin-Jumat: jam 09.00-21.00 WIB
								</Typography>
								<Typography variant="body2" color="white" sx={{ mb: 1.2 }}>
									Sabtu: jam 09.00-18.00 WIB
								</Typography>
								<Typography variant="body2" color="white" sx={{ mb: 1.2 }}>
									Minggu & Hari Libur: Tutup
								</Typography>
								<Typography variant="body2" color="white" sx={{ mb: 1.2 }}>
									Ramadhan:
								</Typography>
								<Typography variant="body2" color="white" sx={{ mb: 1.2 }}>
									Senin - Jumat: 11.00 – 18.00 WIB
								</Typography>
								<Typography variant="body2" color="white" sx={{ mb: 1.2 }}>
									Sabtu: 11.00 - 15.00 WIB
								</Typography>
							</Box>
						</Grid>
						<Grid item xs={12} sm={6} md={3}>
							<Box mb={2}>
								<Typography variant="h5" color="white" sx={sectionTitleSx}>
									Kantor Brofesional
								</Typography>
							</Box>
							<Box>
								{address.map((contact, index) => (
									<Box
										key={`footer-address-${index}`}
										sx={{ display: "flex", alignItems: "center", mb: 1.25 }}>
										{contact.icon}
										<Link href={contact.href} target="_blank" rel="noopener noreferrer" sx={linkSx}>
											<Typography variant="body1" color="white">
												{contact.label}
											</Typography>
										</Link>
									</Box>
								))}
							</Box>
						</Grid>
					</Grid>
				</Container>
			</FooterUpper>
		);
	};

	const FooterLowerComponent = () => {
		const year = new Date().getFullYear();
		return (
			<FooterLower
				className="footer-wrapper"
				sx={{ position: "relative" }}
				id="footer">
				<Container>
					<Grid container spacing={4} pb={4}>
						<Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
							<Box
								display="flex"
								flexDirection="column"
								alignItems="center"
								justifyContent="center"
								height="100%"
								sx={{ alignItems: { xs: "flex-start", md: "flex-start" } }}>
								<Typography variant="subtitle1" color="white">
									&copy; {year} Brofesional. All rights reserved.
								</Typography>
							</Box>
						</Grid>
						<Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
							<Box display="flex" alignItems="center" justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
								<Box>
									<Typography variant="subtitle1" color="white">
										<Link
											href={`${baseUrl}/privacy-policy`}
											target="_blank"
											rel="noopener noreferrer"
											color="white">
											Privacy Policy
										</Link>
									</Typography>
									<Typography variant="subtitle1" color="white">
										<Link
											href={`${baseUrl}/terms-of-services`}
											target="_blank"
											rel="noopener noreferrer"
											color="white">
											Terms of Service
										</Link>
									</Typography>
									<Typography variant="subtitle1" color="white">
										<Link
											href={`${baseUrl}/about`}
											target="_blank"
											rel="noopener noreferrer"
											color="white">
											About Brofesional
										</Link>
									</Typography>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</FooterLower>
		);
	};

	return (
		<>
			<FooterUpperComponent />
			<FooterLowerComponent />
		</>
	);
}

export default FooterHome;